import React from 'react'

export const LoaderInput = () => (
  <div className="form-control loader-input">
    <div className="spinner-border" role="status"></div>
  </div>
)